var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.activeMappedItem)?_c('v-list-tile',{staticClass:"grey--text font-italic"},[_vm._v("Selecciona un atributo para mapearlo a algún valor")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }